import request from '@/utils/request';


const getApiPath = (getParameter = false) => {
    const urlParams = new URLSearchParams(window.location.search);
    // 将 URLSearchParams 转换为对象
    const params = Object.fromEntries(urlParams.entries());

    const apiPath = !params['SHOP_ID'] || params['SHOP_ID'] == 0?'store':'storeAdmin'
    if(getParameter){
        return params
    }else{ 
        return apiPath
    }
}

const apiPath = getApiPath()
const pathParams = getApiPath(true)


export const getPrice = (codes) => {
    return request.post(`/${apiPath}/goods_price/getGoldPrice`,{
        codes,
        ...pathParams
    })
}